import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Alert, Tooltip, Card} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import moment from 'moment';

import {Order} from '../../interfaces';
import {GET_ORDERS} from '../../graphql';
import {getIntoObject} from '../../helpers';

import ListOrders from './components/ListOrders';

interface Properties {
  regionId: string;
}

class OrdersHistory extends Component<Properties> {
  render() {
    const {regionId} = this.props;
    return (
      <Query query={GET_ORDERS} variables={{regionId, first: 10}} notifyOnNetworkStatusChange>
        {({loading, refetch, error, data: {orders, clubs}}: any) => {
          if (error) {
            return `Error! ${error.message}`;
          }
          const columns: Array<ColumnProps<Order>> = [
            {
              title: 'Date',
              key: 'date',
              render: (order: Order) => {
                const date: Date = Number(order.createdAt) ? new Date(Number(order.createdAt)) : new Date(order.createdAt);

                return (
                  <Tooltip title={moment(date).format('HH:mm')}>
                    <span>{moment(date).format('YYYY-MM-DD')}</span>
                  </Tooltip>
                );
              }
            },
            {
              title: 'Person source',
              key: 'source',
              render: ({order}: Order) => getIntoObject(order, ['source'], 'osp')
            },
            {
              title: 'Reference',
              dataIndex: 'reference',
              key: 'reference'
            },
            {
              title: 'Email',
              key: 'email',
              render: ({order}: Order) => getIntoObject(order, ['person', 'email'], '-')
            },
            {
              title: 'Price',
              key: 'price',
              render: ({order, payment}: Order) =>
                getIntoObject(order, ['contract', 'price', 'totalAmount'], '-') + ' ' + getIntoObject(payment, ['currency'], '')
            },
            {
              title: 'Membership ID',
              key: 'membershipExternalID',
              render: ({order}: Order) => getIntoObject(order, ['currentMembership', 'externalId'], '-')
            },
            {
              title: 'MemberID',
              key: 'member_id',
              render: ({order}: Order) => getIntoObject(order, ['prospect', 'personExternalId'], '-')
            },
            {
              title: 'Country',
              key: 'country',
              render: ({order}: Order) => getIntoObject(order, ['person', 'country'], '-')
            },
            {
              title: 'Club',
              key: 'club',
              render: ({order}: Order) => getIntoObject(order, ['currentClub', 'name'], '-')
            },
            {
              title: 'Error',
              key: 'error',
              render: ({order}: Order) =>
                (order.history.some((i: any) => i.err && (i.type === 'error' || i.type === undefined)) && (
                  <Alert message="There is some error in this order" type="error" showIcon style={{width: 270}} />
                )) ||
                '-'
            }
          ];
          return (
            <ListOrders
              columns={columns}
              orderData={orders ? orders.orders : []}
              totalPages={orders ? orders.totalCount : 0}
              refetch={refetch}
              regionId={regionId}
              loading={loading}
              clubs={clubs || []}
            />
          );
        }}
      </Query>
    );
  }
}

export default OrdersHistory;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/ListOrdersWrap.tsx